import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { CusromAlert } from '../environments/customAlertCountrole';
import { DownloadExcel } from '../environments/downloadExcel';
import { RestProvider } from '../environments/rest';

import { HttpClientModule } from '@angular/common/http';
import { AngularFireModule } from '@angular/fire';
import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { IonicStorageModule } from '@ionic/storage'
import { Network } from '@ionic-native/network/ngx';
import { DatePipe } from '@angular/common';
import { HashLocationStrategy, LocationStrategy  } from '@angular/common';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { Globalization } from '@ionic-native/globalization/ngx';

import { Push, PushObject, PushOptions } from '@ionic-native/push/ngx';

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [BrowserModule,
    IonicStorageModule.forRoot(),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireMessagingModule,  
    IonicModule.forRoot(), 
    AppRoutingModule, 
    HttpClientModule, 
    ServiceWorkerModule.register('ngsw-worker.js', 
    { enabled: environment.production })
  ],
  providers: [
    StatusBar,
    SplashScreen,
    //{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide : LocationStrategy , useClass: HashLocationStrategy},
    CusromAlert,
    DownloadExcel,
    RestProvider,
    Network,
    DatePipe,
    Geolocation,
    Globalization,
    Push
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
